<template>
<q-footer bordered class="bg-white text-primary" id="footer">
  <div class="row text-center q-py-sm">
    <div class="text-neutral-90 col-6">
      Copyright HIOR {{ year }}
    </div>
    <div :class="`col-sm-${linkColumnSize} col-xs-6`">
      <template v-if="$auth()">
      <common-link v-if="hasManuals"
                   :href="$route('manuals')"
                   label="Handleidingen"/>
      <common-link v-else
                   is-local
                   label="Handleiding"
                   target="_blank"
                   href="/assets/img/20220177 HIOR uitleg redesign derden.pdf" />
      </template>
    </div>
    <div :class="`col-sm-${linkColumnSize} col-xs-6`"
         v-for="(link, key) in footerLinks"
         :key="key">
      <common-link :label="key"
                   :href="link" />
    </div>
  </div>
</q-footer>
</template>

<script>
import { config } from '~INSTANCE'

export default {
  computed: {
    year () {
      return new Date().getFullYear()
    },
    footerLinks () {
      const links = {
        'Privacy statement': this.$route('user_management.privacy-statement'),
      }
      if (!config.footerLinks) {
        return links
      } else {
        return {
          ...links,
          ...config.footerLinks,
        }
      }
    },
    linkColumnSize () {
      return Math.floor(6 / (Object.keys(this.footerLinks).length + 1))
    },
    hasManuals () {
      return !!config.manuals
    },
  },
}
</script>
